import styled from "@emotion/styled";
export const StyledTimerVerticalTabsComponent = styled.div`
  &.center-align {
    .vertical-timer-tabs {
      .desktop-wrapper {
        .timer-vertical-tabs-desktop-component {
          .vertical-timer-tabs-container {
            justify-content: center;

            .desktop-tabs-text-container {
              .vertical-timer-tab-desktop-container {
                margin-bottom: var(--tab-space, 32px);
              }
            }
          }
        }
      }
    }
  }
`;
